module.exports = __webpack_public_path__ + "static/media/SpectrumAC Statement of Terms and Conditions.c7bdd584.pdf";